// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardForm-paymentIconList-tM1ld {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 10px;
}

.CardForm-paymentIconList-tM1ld img {
    width: 32px;
    height: 22px;
    -o-object-fit: contain;
       object-fit: contain;
}

.CardForm-poweredStripeIcon-FWIMb {
    height: 34px;
    width: 150px;
    -o-object-fit: contain;
       object-fit: contain;
}

.CardForm-paymentIconRow-ZlXed {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 10px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.CardForm-paymentCardInnerBox-YTgB5 {
    padding: 24px;
    background-color: var(--background-secondary);
    border-radius: var(--radius-3);
}

.CardForm-walletAmountRow-aF1Mg,
.CardForm-paymentChooseTabRow-sqGNx {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 12px 18px;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.CardForm-walletAmountRow-aF1Mg {
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    margin-bottom: 18px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.CardForm-paymentTab-aSStx {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 12px 18px;
    border-radius: var(--radius-rounded);
    border: 1px solid var(--primary-border);
    max-width: 200px;
    min-width: 165px;
    margin: 0;
    gap: 5px;
}

.CardForm-tabLabelGroup-CwiyA,
.CardForm-totalWalletAmount-iSCy0 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 6px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: var(--primary-foreground);
}

.CardForm-tabLabelGroup-CwiyA>img,
.CardForm-totalWalletAmount-iSCy0>img {
    width: 24px;
    height: 24px;
}

.CardForm-isActivePaymentTab-FwBB3 {
    background-color: var(--background-primary);
    -webkit-box-shadow: 0px 4px 6px 0px var(--shadow-6);
            box-shadow: 0px 4px 6px 0px var(--shadow-6);
    border: 1px solid var(--background-primary);
}

.CardForm-totalWalletAmount-iSCy0 {
    padding: 12px 18px;
    background-color: var(--wallet-amount-bg);
    border: 1px solid var(--wallet-amount-border);
    border-radius: var(--radius-2);
    max-width: 300px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

@media (max-width:767px) {
    .CardForm-walletAmountRow-aF1Mg {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
    }

    .CardForm-paymentChooseTabRow-sqGNx {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/CardForm/CardForm.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,6CAA6C;IAC7C,8BAA8B;AAClC;;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,cAAc;IACd,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,QAAQ;AACZ;;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,QAAQ;IACR,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,mDAA2C;YAA3C,2CAA2C;IAC3C,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,6CAA6C;IAC7C,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;IAC1B;;IAEA;QACI,mBAAe;YAAf,eAAe;IACnB;AACJ","sourcesContent":[".paymentIconList {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.paymentIconList img {\n    width: 32px;\n    height: 22px;\n    object-fit: contain;\n}\n\n.poweredStripeIcon {\n    height: 34px;\n    width: 150px;\n    object-fit: contain;\n}\n\n.paymentIconRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.paymentCardInnerBox {\n    padding: 24px;\n    background-color: var(--background-secondary);\n    border-radius: var(--radius-3);\n}\n\n.walletAmountRow,\n.paymentChooseTabRow {\n    display: flex;\n    gap: 12px 18px;\n    align-items: flex-start;\n}\n\n.walletAmountRow {\n    justify-content: space-between;\n    margin-bottom: 18px;\n    flex-wrap: wrap;\n}\n\n.paymentTab {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 18px;\n    border-radius: var(--radius-rounded);\n    border: 1px solid var(--primary-border);\n    max-width: 200px;\n    min-width: 165px;\n    margin: 0;\n    gap: 5px;\n}\n\n.tabLabelGroup,\n.totalWalletAmount {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px;\n    color: var(--primary-foreground);\n}\n\n.tabLabelGroup>img,\n.totalWalletAmount>img {\n    width: 24px;\n    height: 24px;\n}\n\n.isActivePaymentTab {\n    background-color: var(--background-primary);\n    box-shadow: 0px 4px 6px 0px var(--shadow-6);\n    border: 1px solid var(--background-primary);\n}\n\n.totalWalletAmount {\n    padding: 12px 18px;\n    background-color: var(--wallet-amount-bg);\n    border: 1px solid var(--wallet-amount-border);\n    border-radius: var(--radius-2);\n    max-width: 300px;\n    flex-wrap: wrap;\n}\n\n@media (max-width:767px) {\n    .walletAmountRow {\n        flex-direction: column;\n    }\n\n    .paymentChooseTabRow {\n        flex-wrap: wrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentIconList": `CardForm-paymentIconList-tM1ld`,
	"poweredStripeIcon": `CardForm-poweredStripeIcon-FWIMb`,
	"paymentIconRow": `CardForm-paymentIconRow-ZlXed`,
	"paymentCardInnerBox": `CardForm-paymentCardInnerBox-YTgB5`,
	"walletAmountRow": `CardForm-walletAmountRow-aF1Mg`,
	"paymentChooseTabRow": `CardForm-paymentChooseTabRow-sqGNx`,
	"paymentTab": `CardForm-paymentTab-aSStx`,
	"tabLabelGroup": `CardForm-tabLabelGroup-CwiyA`,
	"totalWalletAmount": `CardForm-totalWalletAmount-iSCy0`,
	"isActivePaymentTab": `CardForm-isActivePaymentTab-FwBB3`
};
module.exports = ___CSS_LOADER_EXPORT___;
